<template>
	<v-container v-if="!isFetcing">
		<v-card v-for="f in feedback" :key="`f-${f._id}`">
			<v-card-title><h3>{{f.route.displayName['fi']}} - {{f.checkpoint.properties.name['fi']}}</h3>&nbsp; {{f.created_at}}</v-card-title>
			<v-card-text><h4>{{f.subtask.question.description['fi']}}</h4>
				<hr>
				{{f.content}}
			</v-card-text>
			
		</v-card>
		<div class="text-xs-left">
			<v-btn :to="{name: 'routesIndex'}" flat small>{{translater.__('Close')}}</v-btn>
		</div>
	</v-container>
	<v-container v-else>...Loading</v-container>
</template>


<script>
	export default {
		name: 'Feedback',

		mounted()
		{
			this.$nextTick(() => {
				this.$store.dispatch('routes/feedback', this.$route.params.id)
			})
		},

		computed: {
			isFetcing:
			{
				get()
				{
					return this.$store.getters['routes/isFetcing'];
				}
			},

			feedback: {
				get()
				{
					return this.$store.getters['routes/feedback'];
				}
			},

			translater: {
				get()
				{
					return this.$store.getters['translate/translater'];
				}
			}
		},

		


	}
</script>